/**
 * usePlatformAdmin — is the signed-in user a Karr platform admin?
 *
 * Calls the `am_i_platform_admin` RPC (00145) once per auth user and shares the
 * boolean across the app. Used to gate admin-only UI (coupons management, the
 * dunning-phase preview). UX-only: real enforcement is the is_platform_admin()
 * guard inside each SECURITY DEFINER RPC / RLS policy.
 *
 * @since 1.0.0
 */
import { useAuth } from './useAuth';
import { supabase } from '@/db/supabase';
import { createSharedRead } from '@/shared/lib/sharedRead';

// One answer per auth user for the whole app, one call in flight (fastphone-2).
// The old module cache was checked before the first answer landed, so every
// component mounted on the cold open asked: six calls for one boolean.
const adminRead = createSharedRead<boolean>(async () => {
    const { data } = await supabase.rpc('am_i_platform_admin');
    return data === true;
});

export function usePlatformAdmin(): boolean {
    const userId = useAuth((s) => s.user?.id) ?? '';
    return adminRead.use(userId || null).value ?? false;
}
